import { type LoaderFunctionArgs, redirect } from 'react-router';
import { sessionRefresher, sessionStore } from '@/shared/api';
import { paths, safeReturnTo } from '@/shared/lib/paths';

/** Boot silencioso da sessão: com sessão válida, volta direto ao destino. */
export async function loginLoader({ request }: LoaderFunctionArgs): Promise<null> {
  const returnTo = safeReturnTo(new URL(request.url).searchParams.get('returnTo'));
  const { status } = sessionStore.getState();
  const outcome = status === 'unknown' ? await sessionRefresher.refresh() : status;
  if (outcome === 'authenticated') throw redirect(returnTo);
  if (outcome === 'forbidden') throw redirect(paths.forbidden());
  return null;
}
